import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import styled from 'styled-components';
var Clickable = /*#__PURE__*/forwardRef(function (/** @type { HTMLAttributes<HTMLButtonElement> } */props, ref) {
  return __jsx(StyledButton, _extends({}, props, {
    ref: ref
  }));
});
export default Clickable;
var StyledButton = styled.button.withConfig({
  displayName: "clickable__StyledButton",
  componentId: "sc-efyts6-0"
})(["appearance:none;border:none;padding:0;background-color:transparent;cursor:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? "default" : "pointer";
});